<p-confirmDialog
  #cd header="Confirmation"
  icon="pi pi-exclamation-triangle"
  [key]="key || undefined"
  [autoZIndex]="true"
  [baseZIndex]="1200"
  [appendTo]="'body'"
  (onHide)="cd.reject()"
>
  <p-footer>
    <div class="flex justify-content-around">
      <button
        type="button"
        pButton
        icon="pi pi-times"
        class="p-button-outlined"
        [ngClass]="cd.confirmation?.rejectButtonStyleClass"

        [label]="cd.confirmation?.rejectLabel || ('common.cancel' | translate)"
        (click)="cd.reject()">
      </button>
      <button
        type="button"
        class="p-button-outlined"
        [ngClass]="cd.confirmation?.acceptButtonStyleClass"
        pButton
        icon="pi pi-check"
        [label]="cd.confirmation?.acceptLabel || ('common.confirm' | translate)"
        (click)="cd.accept()">
      </button>
    </div>
  </p-footer>
</p-confirmDialog>
